import { render, staticRenderFns } from "./FaqWhatDoIDoIfMyDStvChannelsAreNotShowing.vue?vue&type=template&id=97a41dcc&"
import script from "./FaqWhatDoIDoIfMyDStvChannelsAreNotShowing.vue?vue&type=script&lang=ts&"
export * from "./FaqWhatDoIDoIfMyDStvChannelsAreNotShowing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCol,VContainer,VIcon,VRow})
